import { Box, Button, Text } from '@wix/design-system'
import { useContent, useNext } from '@wix/funnel-builder-lizard'
import { constrainedMemory } from 'process'
import React, { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { usePageLogger } from '../../../../bi/mfi'
import { useFlowContext } from '../../../../hooks/useFlowContext'
import { WixMobileBackButton } from '../../../reusable/WixMobileBackButton/WixMobileBackButton'
import { WixMobileContentWrapper } from '../../../reusable/WixMobileContentWrapper/WixMobileContentWrapper'
import { WixMobileFooter } from '../../../reusable/WixMobileFooter/WixMobileFooter'
import { WixMobileHeader } from '../../../reusable/WixMobileHeader/WixMobileHeader'
import { WixMobileHeading } from '../../../reusable/WixMobileHeading/WixMobileHeading'
import { WixMobilePage } from '../../../reusable/WixMobilePage/WixMobilePage'
import { Content } from './StoresFunnelUpgrade.data'
import { storesFunnelUpgradeDataHooks as DataHooks } from './StoresFunnelUpgrade.dataHooks'
import s from './StoresFunnelUpgrade.scss'

export const STORES_FUNNEL_QUERY_PARAMS = {
  templateId: 'template',
  categoryKey: 'category',
}

export const StoresFunnelUpgrade: FC = () => {
  const { content } = useContent<Content>()
  const next = useNext()
  const pageLogger = usePageLogger()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const onBackButtonClick = () => {
    pageLogger.back({
      payload: {},
    })

    window.history.back()
  }

  const onUpgradeButtonClick = () => {
    console.log('NEXT Clicked')
    return

    pageLogger.answer({
      answer: { action: 'upgrade' },
    })

    next({ upgrade_action: { values: ['upgrade'] } })
  }

  const onSkipButtonClick = () => {
    console.log('SKIP Clicked')
    return

    pageLogger.skip({
      payload: {},
    })

    next({ upgrade_action: { values: ['skip'] } })
  }

  const templateId = searchParams.get(STORES_FUNNEL_QUERY_PARAMS.templateId) || ''
  const imageSrc = templateId
    ? `https://www.wix.com/studio/templates/api/preview/${templateId}/mobile`
    : 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=600&fit=crop&crop=center'

  return (
    <WixMobilePage>
      <WixMobileHeader
        leftContent={
          (content.back && (
            <WixMobileBackButton dataHook={DataHooks.back()} onBack={onBackButtonClick} label={content.back} />
          )) ||
          undefined
        }
      />
      <WixMobileContentWrapper>
        <WixMobileHeading textAlign="center" dataHook={DataHooks.title()}>
          {content.title}
        </WixMobileHeading>
        <Text dataHook={DataHooks.subtitle()} className={s.subtitle}>
          {content.subtitle}
        </Text>

        <Box className={s.upgradeContainer}>
          {/* TODO: here probably should be a user's template with some data injection if possible */}
          <iframe
            src={imageSrc}
            title="Copenhagen Concept Store Preview"
            className={s.storeImage}
            data-hook={DataHooks.storeImage()}
          />
        </Box>
      </WixMobileContentWrapper>

      <WixMobileFooter>
        <Box direction="vertical" gap="8px">
          {content.next && (
            <Button size="large" skin="premium" fullWidth onClick={onUpgradeButtonClick} dataHook={DataHooks.next()}>
              {content.next}
            </Button>
          )}

          {content.skip && (
            <Button size="large" priority="secondary" fullWidth onClick={onSkipButtonClick} dataHook={DataHooks.skip()}>
              {content.skip}
            </Button>
          )}
        </Box>
      </WixMobileFooter>
    </WixMobilePage>
  )
}
